<template>
  <form ref="excel" :action="action" method="post" :target="debug ? '_blank' : '_self'">
    <input type="hidden" name="isDebug"     :value="debug ? 1 : 0" />
    <input type="hidden" name="filename"    :value="excelFilename"   />
    <input type="hidden" name="params"      :value="myParams"  ref="params"  />
    <input type="hidden" name="headers"     :value="myHeaders" ref="headers" />
    <input type="hidden" name="excelTop"    :value="excelTop"    />
    <input type="hidden" name="resultSet"   :value="resultSet"   />

    <input type="hidden" name="excelCss"    :value="myExcelCss"    />
    <input type="hidden" name="excelTopRaw" :value="myExcelTopRaw" />

    <span ref="css" class="hide"><slot name="excel-css"/></span>
    <span ref="raw" class="excel-top-raw" :class="{hide:!debug}"><slot name="excel-top-raw" v-bind="{headers: eHeaders}"/></span>

  </form>
</template>

<script>
export default {
  inheritAttrs: false,
  props: {
    debug: {type: Boolean, default: false},
    excelApi: String,
    excelFilename: String,
    excelTop: {default: ''},
    excelCss: {default: ''},
    excelTopRaw: {default: ''},

    excelHeaders: [String, Array, Object],
    excelParam: Function,
    resultSet: {type: String, default: ''}
  },
  data() {
    return {
      action: this.$api + this.excelApi,
      myParams: null,
      myHeaders: null,
      myExcelTopRaw: '',
      myExcelCss: '',
      eHeaders: null,
    }
  },
  watch: {
    excelHeaders() {
      console.log("해더 변경됨!!!!!!")
      this.setValues()
    }
  },
  created() {
    this.setValues()
  },
  methods: {
    setValues() {
      const headers = this.excelHeaders;
      this.eHeaders =
              typeof headers === "object" ? headers :
              typeof headers === "string" ? T.makeJson(headers) : []
    },
    down() {
      console.log("down!!");

      let params = this.excelParam && this.excelParam() || null

      this.myExcelCss    = this.$refs.css.innerHTML
      this.myExcelTopRaw = this.$refs.raw.innerHTML

      this.myHeaders = JSON.stringify(this.eHeaders)
      this.myParams  = JSON.stringify(params)
      // nextTick 를 하지 않으면 빈값으로 넘어간다. data 변수에 값이 설정된 후 옵저버에 의해서 실제로 form input 에 값이 들어가는데 1 tick 이 소요되는 것 같다.
      this.$nextTick(v=>this.$refs.excel.submit())

      // this.$refs.headers.value   = JSON.stringify(eHeaders) // nextTick 안하는 버전
      // this.$refs.params.value    = JSON.stringify(params)
      // 내부변수 변경에 의한 옵저버 셋팅이 아닌 직접 셋팅이기에 nextTick이 필요 없다. 그냥 이걸로 할까.....
      // this.$refs.excel.submit()

    }
  },
}
</script>


<!--

좋은 샘플

<s-excel ref="excel" :debug="true" excel-filename="수임사건 상세 조회"
   excel-api="/proc_excel/N_REPORT_VIA_DTL" result-set="rs1"
  :excel-param="()=>({ ...searchParam(), iv_pgsize: -1})"
  excel-headers="
      text               | value            | format         | align
      순번               | (count)
      증표종류           | caseclsfnm
      증표번호           | rcptno
      수임일             | cntchargdt        | YYYY.MM.DD
      경유일             | viadt             | YYYY.MM.DD
      사건유형           | casetypenm
      관할기관           | isttoutplac
      사건번호           | caseno
      사건명             | casenm
      구분               | clientclsfnm
      위임인             | client
      상대방             | otherside
      건수               | cnt
      사임취하           | cancelclsfnm
      증표명의자         | membnm
      공동수임건수       | realcnt           | %10.2f        | center
      담당변호인목록     | viamemb_list      |               | left
  ">

    <template v-slot:excel-css>
      table.top td { font-size: 16px; font-family: '맑은 고딕', AppleGothic, serif, sans-serif; }
    </template>

    <template v-slot:excel-top-raw="{headers}">

      <table bordr='0' class='top'>
        <tr><td :colspan=headers.length align='center' style='font-size: 20px; font-weight: bold; height: 40px;'>
          수임사건 상세조회
        </td></tr>
        <tr><td :colspan=headers.length align='center' style='font-size: 16px;'>
          ( 기간 : {{ search.iv_viadtfr }} ~ {{ search.iv_viadtto }} )
        </td></tr>
        <tr><td :colspan=headers.length style='height: 35px;'>
          성명 : {{ $store.state.session.user.name }}
        </td></tr>
      </table>
    </template>
  </s-excel>








-->